export const USER_DETAILS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const DROPDOWN_DETAILS = {
  VERTICAL: "Vertical",
  RESELLER: "Reseller",
  RETAILER:"Retailer"
};

export const EMPLOYEE_TYPE = {
  CH: "CH",
  DSA: "DSA",
};
export const Transfer_ID = 'Transfer ID';

export const DashboardTabs = {
  SALES_PERSONS: 'Sales Persons',
  CUSTOMERS: 'Customers',
  LOGOUT:"Logout"
}

export const REPORTING_SALES_PERSON_DROPDOWN_COUNT = 1500;

export const LOCALIZATION_EN = {
   csvFileBeingUploaded: 'CSV File Is Being Uploaded...Please Wait.',
   csvUploadedSuccessfully: 'CSV File Uploaded Successfully',
   somthingWentWrong: 'Something Went Wrong',
   close: 'Close',
};

export const USER_ROLE = {
  ADMIN_TOOL_ADMIN_ACCESS: 'ADMIN_TOOL_ADMIN_ACCESS'
}